import React from 'react';
import { Bars3Icon } from '@heroicons/react/24/outline';
import { useAuth } from '../../context/AuthContextZustand';
import { hasRoutePermission, ROUTES } from '../../constants/permissions';
import { NotificationIcon } from '../notifications/NotificationIcon';
import { ThemeToggle } from './ThemeToggle';

interface HeaderProps {
  onMenuClick: () => void;
  title: string;
}

const Header: React.FC<HeaderProps> = ({ onMenuClick, title }) => {
  const { user } = useAuth();
  const showNotifications = hasRoutePermission(ROUTES.NOTIFICATIONS, user?.permissions);

  return (
    <header className="bg-white dark:bg-gray-800 shadow-sm border-b border-gray-200 dark:border-gray-700">
      <div className="px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center">
            <button
              type="button"
              className="lg:hidden p-2 rounded-xl admin-text-muted hover:admin-text-body hover:bg-gray-100 dark:text-gray-400 dark:hover:text-gray-200 dark:hover:bg-gray-700"
              onClick={onMenuClick}
            >
              <Bars3Icon className="h-6 w-6" />
            </button>
            <h1 className="ml-4 lg:ml-0 text-2xl font-bold admin-text-title dark:text-gray-100">
              {title}
            </h1>
          </div>
          <div className="flex items-center gap-1">
            <ThemeToggle />
            {showNotifications && <NotificationIcon />}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
